import React, { useState, useEffect } from 'react';
import { MdSearch, MdFilterList, MdVisibility } from 'react-icons/md';
import axios from 'axios';
import './AllArticlesPage.css';

const CATEGORIES = ['All', 'Technology', 'Business', 'Health', 'Science', 'Sports'];

const AllArticlesPage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('All');
  const [sortBy, setSortBy] = useState('date');

  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      try {
        const query = category === 'All' ? 'world' : category.toLowerCase();
        const API_URL = process.env.REACT_APP_API_URL || '/api';
        const res = await axios.get(`${API_URL}/news`, {
          params: { q: query, pageSize: 30 }
        });
        if (res.data && res.data.articles) {
          // Add a stable ID and default img for articles that lack one
          const formatted = res.data.articles.map((a, i) => ({
            id: i,
            title: a.title,
            source: a.source?.name || 'Unknown',
            author: a.author || 'Unknown',
            date: a.publishedAt ? new Date(a.publishedAt).toLocaleDateString() : 'Recent',
            rawDate: a.publishedAt ? new Date(a.publishedAt).getTime() : Date.now(),
            img: a.urlToImage || 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?w=50&h=50&fit=crop',
            url: a.url
          }));
          setArticles(formatted);
        }
      } catch (err) {
        console.error('Failed to fetch articles:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, [category]);

  const filtered = articles
    .filter(a => a.title.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => sortBy === 'title' ? a.title.localeCompare(b.title) : b.rawDate - a.rawDate);

  return (
    <div className="articles-page">
      {/* Header */}
      <div className="articles-page__header">
        <div>
          <h2>All Articles</h2>
          <p>{loading ? 'Loading...' : `${filtered.length} live articles found`}</p>
        </div>
      </div>

      {/* Filters */}
      <div className="articles-filters">
        <div className="filter-search">
          <MdSearch />
          <input
            placeholder="Search titles..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div className="filter-group">
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              className={`filter-btn ${category === cat ? 'active' : ''}`}
              onClick={() => setCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
        <div className="filter-sort">
          <MdFilterList />
          <select value={sortBy} onChange={e => setSortBy(e.target.value)}>
            <option value="date">Latest First</option>
            <option value="title">A-Z</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="table-card">
        <div className="table-wrapper">
          <table className="articles-table articles-table--full">
            <thead>
              <tr>
                <th>Article</th>
                <th>Source</th>
                <th>Author</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '2rem' }}>
                    Loading real-time articles...
                  </td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '2rem' }}>
                    No articles found for your search.
                  </td>
                </tr>
              ) : (
                filtered.map((article, i) => (
                  <tr
                    key={article.id}
                    className="animate-fade-in"
                    style={{ animationDelay: `${i * 0.04}s` }}
                  >
                    <td>
                      <a href={article.url} target="_blank" rel="noopener noreferrer" className="article-title-cell" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <img src={article.img} alt="" className="article-thumbnail" />
                        <span className="table-title">{article.title}</span>
                      </a>
                    </td>
                    <td><span className="table-cat">{article.source}</span></td>
                    <td><span className="table-author" style={{ opacity: 0.8, fontSize: '0.85rem' }}>{article.author}</span></td>
                    <td className="table-date">{article.date}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AllArticlesPage;
